import {
    SET_REQUESTS_GRID_FILTERS,
    SET_ASSET_GRID_FILTERS,
    SET_HOME_PENDING_APPROVAL_GRID_FILTERS,
    SET_HOME_MY_ORDERS_GRID_FILTERS,
    SET_HOME_FLEET_PROCESSING_GRID_FILTERS,
    SET_ALL_PENDING_APPROVAL_GRID_FILTERS,
    SET_BULK_ORDER_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_GRID_FILTERS,
    SET_REQUEST_TOTAL_ORDER_FILTERS,
    SET_REQUEST_PENDING_APPROVAL_FILTERS,
    SET_REQUEST_FLEET_PROCESSING_FILTERS,
    SET_REQUEST_COMPLETED_FILTERS,
    SET_REQUEST_RETURNED_FILTERS,
    SET_REQUEST_PENDING_FLEET_FILTERS,
    SET_REQUEST_REJECTED_FILTERS,
    SET_REQUEST_CANCELLED_FILTERS,
    SET_DISPOSITION_PENALTY_FEES_FILTERS,
    SET_ASSET_TOTAL_ORDER_FILTERS,
    SET_ASSET_PENDING_APPROVAL_FILTERS,
    SET_ASSET_FLEET_PROCESSING_FILTERS,
    SET_ASSET_COMPLETED_FILTERS,
    SET_ASSET_RETURNED_FILTERS,
    SET_ASSET_PENDING_FLEET_FILTERS,
    SET_ASSET_REJECTED_FILTERS,
    SET_ASSET_CANCELLED_FILTERS,
    SET_BULK_ORDER_TOTAL_ORDER_FILTERS,
    SET_BULK_ORDER_PENDING_APPROVAL_FILTERS,
    SET_BULK_ORDER_FLEET_PROCESSING_FILTERS,
    SET_BULK_ORDER_COMPLETED_FILTERS,
    SET_BULK_ORDER_RETURNED_FILTERS,
    SET_BULK_ORDER_REJECTED_FILTERS,
    SET_BULK_ORDER_CANCELLED_FILTERS,
    SET_ACQUISITION_CODE_MAINTENANCE_FILTERS,
    SET_CATALOG_MANAGEMENT_VEHICLE_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_MOWER_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_CONSTRUCTION_EQUIPMENT_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_SNOW_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_STANDARDIZED_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_TRAILERS_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_UTILITY_VEHICLE_GRID_FILTERS,
    SET_CATALOG_MANAGEMENT_TREE_CARE_GRID_FILTERS,
    SET_REQUEST_SAVED_ORDER_FILTERS,
    SET_ASSET_SAVED_ORDER_FILTERS,
    SET_BULK_ORDER_SAVED_ORDER_FILTERS,
    SET_CATALOG_MANAGEMENT_JOB_TITLES_GRID_FILTERS
} from "./GridDataFiltersType"

const initialState = {
    requestGridFilters: {},
    assetGridFilters: {},
    pendingApprovalGridFilters: {},
    myOrdersGridFilters: {},
    fleetProcessingGridFilters: {},
    allPendingApprovalGridFilters: {},
    bulkOrderGridFilters: {},
    catalogManagementGridFilters: {},
    requestTotalOrderGridFilters: {},
    requestSavedOrderGridFilters: {},
    requestPendingApprovalGridFilters: {},
    requestFleetProcessingGridFilters: {},
    requestCompletedGridFilters: {},
    requestRetuernedGridFilters: {},
    requestPendingFleetGridFilters: {},
    requestRejectedGridFilters: {},
    requestCancelledGridFilters: {},
    dispositionPenaltyFeesGridFilters: {},
    assetTotalOrderGridFilters: {},
    assetSavedOrderGridFilters: {},
    assetPendingApprovalGridFilters: {},
    assetFleetProcessingGridFilters: {},
    assetCompletedGridFilters: {},
    assetRetuernedGridFilters: {},
    assetPendingFleetGridFilters: {},
    assetRejectedGridFilters: {},
    assetCancelledGridFilters: {},
    bulkOrderTotalOrderGridFilters: {},
    bulkOrderSavedOrderGridFilters: {},
    bulkOrderPendingApprovalGridFilters: {},
    bulkOrderFleetProcessingGridFilters: {},
    bulkOrderCompletedGridFilters: {},
    bulkOrderReturnedGridFilters: {},
    bulkOrderRejectedGridFilters: {},
    bulkOrderCancelledGridFilters: {},
    acquisitionCodeMaintenanceGridFilters: {},


    vehicleGridFilters: {},
    mowerGridFilters: {},
    constructionEquipmentGridFilters: {},
    snowGridFilters: {},
    standardizedGridFilters: {},
    trailersGridFilters: {},
    utilityVehicleGridFilters: {},
    treeCareGridFilters: {},
    jobTitlesGridFilters: {}
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_REQUESTS_GRID_FILTERS:
            return {
                ...state,
                requestGridFilters: { ...state.requestGridFilters, ...action.requestFilters }
            };
        case SET_ASSET_GRID_FILTERS:
            return {
                ...state,
                assetGridFilters: { ...state.assetGridFilters, ...action.assetFilters },
            };
        case SET_HOME_PENDING_APPROVAL_GRID_FILTERS:
            return {
                ...state,
                pendingApprovalGridFilters: { ...state.pendingApprovalGridFilters, ...action.pendingApprovalFilters },
            };
        case SET_HOME_MY_ORDERS_GRID_FILTERS:
            return {
                ...state,
                myOrdersGridFilters: { ...state.myOrdersGridFilters, ...action.myOrdersFilters },
            };
        case SET_HOME_FLEET_PROCESSING_GRID_FILTERS:
            return {
                ...state,
                fleetProcessingGridFilters: { ...state.fleetProcessingGridFilters, ...action.fleetFilters },
            };
        case SET_BULK_ORDER_GRID_FILTERS:
            return {
                ...state,
                bulkOrderGridFilters: { ...state.bulkOrderGridFilters, ...action.bulkOrderFilters },
            };
        case SET_CATALOG_MANAGEMENT_GRID_FILTERS:
            return {
                ...state,
                catalogManagementGridFilters: { ...state.catalogManagementGridFilters, ...action.catalogManagementFilters },
            };
        case SET_ALL_PENDING_APPROVAL_GRID_FILTERS:
            return {
                ...state,
                allPendingApprovalGridFilters: { ...state.allPendingApprovalGridFilters, ...action.allPendingApprovalFilters },
            };
        case SET_REQUEST_TOTAL_ORDER_FILTERS:
            return {
                ...state,
                requestTotalOrderGridFilters: { ...state.requestTotalOrderGridFilters, ...action.requestTotalOrderFilters },
            };
        case SET_REQUEST_SAVED_ORDER_FILTERS:
            return {
                ...state,
                requestSavedOrderGridFilters: { ...state.requestSavedOrderGridFilters, ...action.requestSavedOrderFilters },
            };
        case SET_REQUEST_PENDING_APPROVAL_FILTERS:
            return {
                ...state,
                requestPendingApprovalGridFilters: { ...state.requestPendingApprovalGridFilters, ...action.requestPendingApprovalFilters },
            };
        case SET_REQUEST_FLEET_PROCESSING_FILTERS:
            return {
                ...state,
                requestFleetProcessingGridFilters: { ...state.requestFleetProcessingGridFilters, ...action.requestFleetProcessingFilters },
            };
        case SET_REQUEST_COMPLETED_FILTERS:
            return {
                ...state,
                requestCompletedGridFilters: { ...state.requestCompletedGridFilters, ...action.requestCompletedFilters },
            };
        case SET_REQUEST_RETURNED_FILTERS:
            return {
                ...state,
                requestRetuernedGridFilters: { ...state.requestRetuernedGridFilters, ...action.requestRetuernedFilters },
            };
        case SET_REQUEST_PENDING_FLEET_FILTERS:
            return {
                ...state,
                requestPendingFleetGridFilters: { ...state.requestPendingFleetGridFilters, ...action.requestPendingFleetFilters },
            };
        case SET_REQUEST_REJECTED_FILTERS:
            return {
                ...state,
                requestRejectedGridFilters: { ...state.requestRejectedGridFilters, ...action.requestRejectedFilters },
            };
        case SET_REQUEST_CANCELLED_FILTERS:
            return {
                ...state,
                requestCancelledGridFilters: { ...state.requestCancelledGridFilters, ...action.requestCancelledFilters },
            };
        case SET_DISPOSITION_PENALTY_FEES_FILTERS:
            return {
                ...state,
                dispositionPenaltyFeesGridFilters: { ...state.dispositionPenaltyFeesGridFilters, ...action.dispositionPenaltyFeesFilters },
            };

        case SET_ASSET_TOTAL_ORDER_FILTERS:
            return {
                ...state,
                assetTotalOrderGridFilters: { ...state.assetTotalOrderGridFilters, ...action.assetTotalOrderFilters },
            };
        case SET_ASSET_SAVED_ORDER_FILTERS:
            return {
                ...state,
                assetSavedOrderGridFilters: { ...state.assetSavedOrderGridFilters, ...action.assetSavedOrderFilters },
            };
        case SET_ASSET_PENDING_APPROVAL_FILTERS:
            return {
                ...state,
                assetPendingApprovalGridFilters: { ...state.assetPendingApprovalGridFilters, ...action.assetPendingApprovalFilters },
            };
        case SET_ASSET_FLEET_PROCESSING_FILTERS:
            return {
                ...state,
                assetFleetProcessingGridFilters: { ...state.assetFleetProcessingGridFilters, ...action.assetFleetProcessingFilters },
            };
        case SET_ASSET_COMPLETED_FILTERS:
            return {
                ...state,
                assetCompletedGridFilters: { ...state.assetCompletedGridFilters, ...action.assetCompletedFilters },
            };
        case SET_ASSET_RETURNED_FILTERS:
            return {
                ...state,
                assetRetuernedGridFilters: { ...state.assetRetuernedGridFilters, ...action.assetRetuernedFilters },
            };
        case SET_ASSET_PENDING_FLEET_FILTERS:
            return {
                ...state,
                assetPendingFleetGridFilters: { ...state.assetPendingFleetGridFilters, ...action.assetPendingFleetFilters },
            };
        case SET_ASSET_REJECTED_FILTERS:
            return {
                ...state,
                assetRejectedGridFilters: { ...state.assetRejectedGridFilters, ...action.assetRejectedFilters },
            };
        case SET_ASSET_CANCELLED_FILTERS:
            return {
                ...state,
                assetCancelledGridFilters: { ...state.assetCancelledGridFilters, ...action.assetCancelledFilters },
            };

        case SET_BULK_ORDER_TOTAL_ORDER_FILTERS:
            return {
                ...state,
                bulkOrderTotalOrderGridFilters: { ...state.bulkOrderTotalOrderGridFilters, ...action.bulkOrderTotalOrderFilters },
            };
        case SET_BULK_ORDER_SAVED_ORDER_FILTERS:
            return {
                ...state,
                bulkOrderSavedOrderGridFilters: { ...state.bulkOrderSavedOrderGridFilters, ...action.bulkOrderSavedOrderFilters },
            };
        case SET_BULK_ORDER_PENDING_APPROVAL_FILTERS:
            return {
                ...state,
                bulkOrderPendingApprovalGridFilters: { ...state.bulkOrderPendingApprovalGridFilters, ...action.bulkOrderPendingApprovalFilters },
            };
        case SET_BULK_ORDER_FLEET_PROCESSING_FILTERS:
            return {
                ...state,
                bulkOrderFleetProcessingGridFilters: { ...state.bulkOrderFleetProcessingGridFilters, ...action.bulkOrderFleetProcessingFilters },
            };
        case SET_BULK_ORDER_COMPLETED_FILTERS:
            return {
                ...state,
                bulkOrderCompletedGridFilters: { ...state.bulkOrderCompletedGridFilters, ...action.bulkOrderCompletedFilters },
            };
        case SET_BULK_ORDER_RETURNED_FILTERS:
            return {
                ...state,
                bulkOrderReturnedGridFilters: { ...state.bulkOrderReturnedGridFilters, ...action.bulkOrderReturnedFilters },
            };
        case SET_BULK_ORDER_REJECTED_FILTERS:
            return {
                ...state,
                bulkOrderRejectedGridFilters: { ...state.bulkOrderRejectedGridFilters, ...action.bulkOrderRejectedFilters },
            };
        case SET_BULK_ORDER_CANCELLED_FILTERS:
            return {
                ...state,
                bulkOrderCancelledGridFilters: { ...state.bulkOrderCancelledGridFilters, ...action.bulkOrderCancelledFilters },
            };
        case SET_ACQUISITION_CODE_MAINTENANCE_FILTERS:
            return {
                ...state,
                acquisitionCodeMaintenanceGridFilters: { ...state.acquisitionCodeMaintenanceGridFilters, ...action.acquisitionFilters },
            };
        case SET_CATALOG_MANAGEMENT_VEHICLE_GRID_FILTERS:
            return {
                ...state,
                vehicleGridFilters: { ...state.vehicleGridFilters, ...action.vehicleGridFilters },
            };
        case SET_CATALOG_MANAGEMENT_MOWER_GRID_FILTERS:
            return {
                ...state,
                mowerGridFilters: { ...state.mowerGridFilters, ...action.mowerGridFilters },
            };
        case SET_CATALOG_MANAGEMENT_CONSTRUCTION_EQUIPMENT_GRID_FILTERS:
            return {
                ...state,
                constructionEquipmentGridFilters: { ...state.constructionEquipmentGridFilters, ...action.constructionEquipmentGridFilters },
            };
        case SET_CATALOG_MANAGEMENT_SNOW_GRID_FILTERS:
            return {
                ...state,
                snowGridFilters: { ...state.snowGridFilters, ...action.snowGridFilters },
            };
        case SET_CATALOG_MANAGEMENT_STANDARDIZED_GRID_FILTERS:
            return {
                ...state,
                standardizedGridFilters: { ...state.standardizedGridFilters, ...action.standardizedGridFilters },
            };
        case SET_CATALOG_MANAGEMENT_TRAILERS_GRID_FILTERS:
            return {
                ...state,
                trailersGridFilters: { ...state.trailersGridFilters, ...action.trailersGridFilters },
            };
        case SET_CATALOG_MANAGEMENT_UTILITY_VEHICLE_GRID_FILTERS:
            return {
                ...state,
                utilityVehicleGridFilters: { ...state.utilityVehicleGridFilters, ...action.utilityVehicleGridFilters },
            };
        case SET_CATALOG_MANAGEMENT_TREE_CARE_GRID_FILTERS:
            return {
                ...state,
                treeCareGridFilters: { ...state.treeCareGridFilters, ...action.treeCareGridFilters },
            };
        case SET_CATALOG_MANAGEMENT_JOB_TITLES_GRID_FILTERS:
            return {
                ...state,
                jobTitlesGridFilters: { ...state.jobTitlesGridFilters, ...action.jobTitlesGridFilters },
            };
        default:
            return state;
    }
};

export default reducer;